export default [
  [
    -73.88261675834656,
    40.866000194303815
  ],
  [
    -73.8822466135025,
    40.86610161416351
  ],
  [
    -73.88171017169952,
    40.866320680530414
  ],
  [
    -73.88110935688019,
    40.86659654085045
  ],
  [
    -73.88067483901978,
    40.86682777582161
  ],
  [
    -73.88014912605286,
    40.86722533581436
  ],
  [
    -73.87968242168427,
    40.86755392951695
  ],
  [
    -73.87917280197144,
    40.867878464906696
  ],
  [
    -73.8790225982666,
    40.86796771186005
  ],
  [
    -73.87855589389801,
    40.86847479453894
  ],
  [
    -73.87841641902924,
    40.86869385305515
  ],
  [
    -73.87802481651306,
    40.86889668436841
  ],
  [
    -73.87775123119354,
    40.86900215640581
  ],
  [
    -73.87753129005432,
    40.869018382858165
  ],
  [
    -73.87726306915283,
    40.86898187333474
  ],
  [
    -73.87693583965302,
    40.86893319393886
  ],
  [
    -73.87661933898926,
    40.86883177841578
  ],
  [
    -73.87647449970245,
    40.86871819284555
  ],
  [
    -73.87621700763702,
    40.868308471848216
  ],
  [
    -73.87587904930115,
    40.86806101536447
  ],
  [
    -73.87573957443237,
    40.86793525843638
  ],
  [
    -73.8756215572357,
    40.86773648086939
  ],
  [
    -73.87535870075224,
    40.86727401646577
  ],
  [
    -73.87505829334259,
    40.8669981589679
  ],
  [
    -73.87344896793365,
    40.86655191646482
  ],
  [
    -73.87299835681915,
    40.866105670954674
  ],
  [
    -73.87260138988495,
    40.86559045648929
  ],
  [
    -73.87222588062286,
    40.86494947541733
  ],
  [
    -73.87208104133606,
    40.864442365743265
  ],
  [
    -73.87218296527863,
    40.86293724136536
  ],
  [
    -73.87267112731934,
    40.85925339642935
  ],
  [
    -73.87274086475371,
    40.858604239525185
  ],
  [
    -73.87292325496674,
    40.85800782101204
  ],
  [
    -73.87311100959778,
    40.857675122637474
  ],
  [
    -73.87338995933533,
    40.857281562646726
  ],
  [
    -73.87376546859741,
    40.856851484106905
  ],
  [
    -73.87415170669556,
    40.85639300107919
  ],
  [
    -73.87444138526917,
    40.85613332786835
  ],
  [
    -73.87479543685912,
    40.855995376061095
  ],
  [
    -73.8752031326294,
    40.85585336654765
  ],
  [
    -73.87551963329314,
    40.85575193099453
  ],
  [
    -73.8768982887268,
    40.85552877223097
  ],
  [
    -73.87725234031676,
    40.85552471479197
  ],
  [
    -73.87755274772644,
    40.85556123173421
  ],
  [
    -73.87785315513611,
    40.85563020812578
  ],
  [
    -73.87826085090637,
    40.8558006200794
  ],
  [
    -73.87861490249634,
    40.855975089006364
  ],
  [
    -73.87909770011902,
    40.856445747075774
  ],
  [
    -73.87941420078278,
    40.85664455853152
  ],
  [
    -73.8807338476181,
    40.85747225695486
  ],
  [
    -73.88072311878204,
    40.857687294558666
  ],
  [
    -73.88079822063445,
    40.85788610228836
  ],
  [
    -73.88083040714264,
    40.85823097142458
  ],
  [
    -73.88070702552795,
    40.85890853261613
  ],
  [
    -73.88041198253632,
    40.860308262830074
  ],
  [
    -73.88031005859375,
    40.860754547404
  ],
  [
    -73.88037979602814,
    40.861014202499675
  ],
  [
    -73.88051927089691,
    40.86116837223112
  ],
  [
    -73.880717754364,
    40.86139962615543
  ],
  [
    -73.88095915317534,
    40.861614651009795
  ],
  [
    -73.8812381029129,
    40.86179721873439
  ],
  [
    -73.88169944286346,
    40.86208121197238
  ],
  [
    -73.88209104537964,
    40.86237737505204
  ],
  [
    -73.88284742832184,
    40.86326179938
  ],
  [
    -73.88366281986237,
    40.86424763459659
  ],
  [
    -73.88382375240326,
    40.86457624307446
  ],
  [
    -73.88383448123932,
    40.864779086999995
  ],
  [
    -73.88376474380493,
    40.86511986339627
  ],
  [
    -73.88349652290343,
    40.86543629705126
  ],
  [
    -73.88318002223969,
    40.86566753607373
  ],
  [
    -73.88270795345306,
    40.865951512715995
  ]
].map((item) => item.reverse())
